import React from "react";
import { SnackbarProvider } from "notistack";
import { Notification } from "./Notification";

type Props = { children: React.ReactNode };

export function WithNotifications({ children }: Props): React.ReactElement {
  return (
    <SnackbarProvider
      preventDuplicate
      maxSnack={5}
      autoHideDuration={10000}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
    >
      {children}
      <Notification />
    </SnackbarProvider>
  );
}
